export const BUTTON_STATES = {
  DEFAULT: 'DEFAULT',
  REQUEST: 'REQUEST',
  REQUEST_DONE: 'REQUEST_DONE',
};
